import React from 'react';
import { ArrowLeftRightIcon, HomeIcon, LaptopIcon } from 'lucide-react';
import type { ModelAccent } from '../types/kit';
interface ModelIconProps {
  accent: ModelAccent;
  className?: string;
}
export function ModelIcon({
  accent,
  className = 'h-5 w-5'
}: ModelIconProps) {
  if (accent === 'airbnb') return <HomeIcon className={className} aria-hidden="true" data-id="element-213" data-mp="b6qr6vf3x1zb" />;
  if (accent === 'arbitraje') return <ArrowLeftRightIcon className={className} aria-hidden="true" data-id="element-214" data-mp="74lwrugu41bm" />;
  return <LaptopIcon className={className} aria-hidden="true" data-id="element-215" data-mp="2dng2trxp17u" />;
}